module.exports = __webpack_public_path__ + "static/media/game_machine.13a504ef.png";